"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WordCloudPinSchema = exports.WordCloudPinSettingsSchema = exports.WordCloudPinLayoutTemplateSchema = exports.WordCloudPinLayoutPartKeySchema = exports.WordCloudPinLayoutKeySettingsSchema = void 0;
const zod_1 = require("zod");
const pin_component_1 = require("../pin-component");
const layout_part_1 = require("../pin-component/layout-part");
const base_pin_1 = require("./base-pin");
exports.WordCloudPinLayoutKeySettingsSchema = zod_1.z.enum(['TITLE_ONLY']);
exports.WordCloudPinLayoutPartKeySchema = layout_part_1.LayoutPartSchema.extract(['TITLE']);
exports.WordCloudPinLayoutTemplateSchema = base_pin_1.BaseTemplateLayoutSchema.merge(zod_1.z.object({
    key: exports.WordCloudPinLayoutKeySettingsSchema,
    layoutParts: zod_1.z.record(exports.WordCloudPinLayoutPartKeySchema, pin_component_1.PinComponentSchema.optional()),
}));
exports.WordCloudPinSettingsSchema = base_pin_1.BaseInteractiveQuestionPinSettingsSchema.merge(zod_1.z.object({
    word: zod_1.z.string().nullish(), // in the 1.0 this was item.custom.word // TODO: Remove, use questionId instead
    layout: exports.WordCloudPinLayoutKeySettingsSchema,
    layoutParts: zod_1.z.record(exports.WordCloudPinLayoutPartKeySchema, zod_1.z.string().optional()),
}));
exports.WordCloudPinSchema = base_pin_1.BasePinSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('WORD_CLOUD'),
    settings: exports.WordCloudPinSettingsSchema,
}));
//# sourceMappingURL=word-cloud-pin.js.map